import React from 'react';

const InputField = ({ label, name, type = 'text', value, onChange, placeholder, required, className = '', inputClassName = '', ...inputProps }) => (
  <div className={className}>
    <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-brand-muted" htmlFor={name}>
      {label}
    </label>
    <input
      id={name}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      {...inputProps}
      className={`field-control w-full rounded-xl px-3 py-2.5 text-sm text-brand-ink outline-none ${type === 'date' ? 'date-input' : ''} ${inputClassName}`}
    />
  </div>
);

export default InputField;